import { render, staticRenderFns } from "./insertrecord.vue?vue&type=template&id=7115afcc&scoped=true&"
import script from "./insertrecord.vue?vue&type=script&lang=js&"
export * from "./insertrecord.vue?vue&type=script&lang=js&"
import style0 from "./insertrecord.vue?vue&type=style&index=0&id=7115afcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7115afcc",
  null
  
)

export default component.exports